import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=3334fbad&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=3334fbad&lang=scss&scoped=true&"
import style1 from "./Company.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334fbad",
  null
  
)

export default component.exports